<template>
  <div class="event-list">
    
    <div class="event-list-container" ref="eventListContainer">
      <!-- 标题 -->
      <!-- <h3 class="event-list-title">事件列表</h3> -->

      <!-- 类型筛选按钮 -->
<!--      <div class="event-type-buttons">-->
<!--        <el-button-->
<!--            v-for="(type, index) in ['投诉', '建议', '报修']"-->
<!--            :key="index"-->
<!--            :type="activeType === type ? 'primary' : 'primary'"-->
<!--            :plain="activeType !== type"-->
<!--            class="type-btn"-->
<!--            @click="handleTypeClick(type)"-->
<!--        >-->
<!--          {{ type }}-->
<!--        </el-button>-->
<!--      </div>-->

      <!-- 事件列表 -->
      <div class="event-items">
        <!-- 处理中事件 -->
        <!-- 使用ref替代ID，更安全的获取方式 -->
      <div class="scroll-wrapper" ref="scrollWrapper">
          <ul  
              infinite-scroll-disabled="loading"
              infinite-scroll-distance="10"
              infinite-scroll-container="this.$refs.scrollWrapper"
              style="padding: 0px;margin: 0px;"
              class="infinite-list"
              ref="infiniteList"
          >
              <li v-for="(item, index) in events" class="infinite-list-item" style="color: #fff;" :key="index">
                <el-card class="event-card">
                  <div slot="header" class="event-status">
                    <i class="el-icon-loading" style="color: rgba(255, 166, 0, 1);" v-if="item.applicationStatus==0"></i>
                    <i class="el-icon-success" style="color: rgba(117, 224, 160, 1);" v-if="item.applicationStatus==1"></i>
                    <i class="el-icon-error" style="color: rgba(255, 58, 58, 1);" v-if="item.applicationStatus==2"></i>
                    <span v-if="item.applicationStatus==1" style="color: rgba(117, 224, 160, 1);">{{ item.applicationStatusValue }}</span>
                    <span v-if="item.applicationStatus==0" style="color: rgba(255, 166, 0, 1);">{{ item.applicationStatusValue }}</span>
                    <span v-if="item.applicationStatus==2" style="color: rgba(255, 58, 58, 1);">{{ item.applicationStatusValue }}</span>
                    <div style="margin-left: auto;">
                      <el-button type="text" class="action-btn" @click="() => onDetail(item.id)">查看详情</el-button>
                      <el-button type="text" class="action-btn1" @click="openAuditDialog(item)" v-if="item.applicationStatus==0">驳回</el-button>
                      <el-button type="text" class="action-btn2" @click="fundaudit(item.id)" v-if="item.applicationStatus==0">同意</el-button>
                    </div>
                  </div>
                  <div class="event-content">
                    <h4 class="community-name">{{item.applicationTypeValue}}</h4>
                    <div class="event-meta">
                        <div style="display: flex;flex-direction: column;">
                            <span style="color: #999;">申请金额</span>
                            <span style="color: #fff;margin-top: 2px;">￥{{item.applicationAmount}}</span>
                        </div>
                        <div style="display: flex;flex-direction: column;">
                            <span style="color: #999;">申请人</span>
                            <span style="color: #fff;margin-top: 2px;">{{item.applicationUser}}</span>
                        </div>
                        <div style="display: flex;flex-direction: column;">
                            <span style="color: #999;">申请时间</span>
                            <span style="color: #fff;margin-top: 2px;">{{item.applicationTime}}</span>
                        </div>
                        <div style="display: flex;flex-direction: column;">
                            <span style="color: #999;">物业单位</span>
                            <span style="color: #fff;margin-top: 2px;">{{item.estateName}}</span>
                        </div>
                    </div>
                    <div style="display: flex;background-color: rgba(18, 59, 55, 0.3);padding: 5px;margin-top: 10px;border-radius: 5px;" v-if="item.applicationStatus==2">
                          <span style="color: #999;">驳回原因：</span>
                          <span style="color: #fff;margin-top: 2px;">{{item.rejectReason}}</span>
                      </div>
                  </div>
                </el-card>
              </li>
            </ul>
        </div>
      </div>
    </div>

    <!-- 进度查看弹窗 -->
    <!-- <vue-progress-dialog
        :visible.sync="progressDialogVisible"
        :event-info="currentEventInfo"
        :processing-steps="currentProcessingSteps"
        :intervention="currentIntervention"
        @close="closeProgressDialog">
    </vue-progress-dialog> -->
    <vue-audit
        :visible.sync="auditDialogVisible"
        :event-info="currentEventInfo"
        @close="closeAuditDialog">
    </vue-audit>
  </div>
</template>

<script>
import VueAudit from './vueaudit.vue';
import {Message} from "element-ui";
import {fundlist,fundaudit} from "@/api/estate";

export default {
  name: 'EventList',
  components: {
    VueAudit
  },
  data() {
    return {
      // 可以在这里添加事件数据
      pageNum:1,
      estateId:'',
      search:'',
      events: [],
      activeType: '投诉', // 默认选中"投诉"
      currentEventInfo: {},
      auditDialogVisible: false,
    }
  },
  mounted() {
      
      // 确保DOM完全渲染后再执行
      this.$nextTick(() => {
          // 安全检查：先确认元素存在
          if (this.$refs.scrollWrapper && this.$refs.infiniteList) {
              // 绑定滚动事件
              this.$refs.scrollWrapper.addEventListener('scroll', this.handleManualScroll);
              // 检查初始内容
              this.ensureEnoughContent();
          } else if (!this._isDestroyed) {
              // 重试机制：100ms后再次尝试
              setTimeout(() => {
                if (!this._isDestroyed) this.mounted();
              }, 100);
          }
      });
  },
  beforeDestroy() {
      // 移除事件前先检查元素是否存在
      if (this.$refs.scrollWrapper) {
          this.$refs.scrollWrapper.removeEventListener('scroll', this.handleManualScroll);
      }
  },
  mounted() {
    this.$on('sync-option',(parentActiveIndex,id,search)=>{
      // console.log(parentActiveIndex,id,search);
      this.estateId=id
      this.search=search
      this.fundlist();
    })
  },
  methods: {
    onDetail(id){
      this.$emit('onDetail', id);
    },
    fundaudit(id){
      let data={};
      data.id=id
      data.applicationStatus=1
      fundaudit(data).then(res=>{
        Message.success('操作成功');
        setTimeout(() => {
          this.fundlist();
        }, 500);
      })
    },
    fundlist(){
      let data={};
      data.estateId=this.estateId
      data.searchValue=this.search
      data.pageNum=this.pageNum
      fundlist(data).then(res=>{
        if(this.pageNum==1){
          this.events = res.rows;
        }else{
          this.events = this.events.concat(res.rows);
        }
        this.loading = false;
      })
    },
    ensureEnoughContent() {
        // 双重安全检查
        if (!this.$refs.scrollWrapper || !this.$refs.infiniteList) return;
        
        const container = this.$refs.scrollWrapper;
        const list = this.$refs.infiniteList;
        
        // 确保容器和列表的高度都有效
        if (container.clientHeight && list.clientHeight && list.clientHeight <= container.clientHeight) {
            // this.load();
        }
    },
    handleManualScroll() {
        if (!this.$refs.scrollWrapper) return;
        
        const container = this.$refs.scrollWrapper;
        const scrollBottom = container.scrollHeight - container.scrollTop - container.clientHeight;
        // console.log('scrollBottom', scrollBottom == 0);
        if (scrollBottom == 0) {
            this.load();
        }
    },
    load() {
        // console.log('加载中...');
        if (this.loading) return;
        
        this.loading = true;
        this.pageNum++
        this.fundlist();
    },

    onUnder() {
      Message.info('功能开发中，敬请期待！');
    },
    handleTypeClick(type) {
      this.activeType = type;
    },
    openAuditDialog(item) {
      this.currentEventInfo = item;
      this.auditDialogVisible = true;
    },
    // 关闭进度弹窗
    closeAuditDialog() {
      this.auditDialogVisible = false;
      this.pageNum=1
      this.events=[]
      this.fundlist();
    },
    // 加载事件数据的方法
    loadEvents(estateId) {
      let data={};
      data.estateId=estateId
      getEstateAllComplaint(data).then(res=>{
        this.events = res.rows;
      })
    }
  }
}
</script>

<style scoped>
.scroll-container {
    padding: 20px;
    width: 1300px;
    height: 750px;
    background: rgba(0,0,0,0.7);
}

.scroll-wrapper {
    width: 1300px;
    height: 730px;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    box-sizing: border-box;
}

.infinite-list-item {
    margin-top: 15px;
    margin-right: 10px;
}

.event-list {
  display: flex;
  flex-direction: column;
  /* align-items: center; */
}

.stats-container {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  padding: 10px 0;
  width: 1300px;
  box-sizing: border-box;
}

.stat-item {
  background-color: rgba(4, 13, 16, 0.8);
  border: 1px solid rgba(30, 82, 79, 1);
  border-radius: 4px;
  padding: 10px 15px;
  color: #fff;
  font-size: 16px;
  text-align: center;
  flex: 1;
  margin: 0 5px;
  box-sizing: border-box;
  position: relative;
}

.stat-item::before,
.stat-item::after {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  width: 1px;
  background-color: #019183;
}

.stat-item::before {
  left: 0;
}

.stat-item::after {
  right: 0;
}

.stat-item .label {
  display: block;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 5px;
}

.stat-item .value {
  font-size: 20px;
  font-weight: bold;
}

.event-list-container {
  background-color: rgb(4, 13, 16, 0.8);
  color: #fff;
  padding: 20px;
  width: 1320px;
  height: 100%;
  box-sizing: border-box;
  overflow-y: auto;
  position: relative;
}

.event-list-title {
  margin: 0 0 20px 0;
  font-size: 18px;
  font-weight: normal;
}

.event-type-buttons {
  margin-bottom: 25px;
}

.type-btn {
  background-color: #0f3d39;
  border-color: #019183;
  margin-right: 10px;
  font-size: 18px;
  padding: 8px 16px;
  border-radius: 4px;
}

.type-btn[plain] {
  background-color: transparent;
  color: #019183;
  border-color: #019183;
}

.type-btn[plain]:hover {
  background-color: rgba(1, 145, 131, 0.1);
}

.type-btn.is-active {
  background-color: #019183;
  color: white;
  border-color: #019183;
}

.event-items {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.event-card {
  background-color: transparent;
  border: 1px solid #2a4361;
  border-radius: 4px;
  overflow: hidden;
}

.event-card::v-deep .el-card__header {
  border-bottom: none !important;
  padding: 0 0 0 0;
  background: rgba(18, 59, 55, 0.3);
}

.event-card::v-deep .el-card__body {
  padding: 0;
}

.event-status {
  display: flex;
  align-items: center;
  padding: 8px 15px;
  font-size: 18px;
  color: rgba(255, 255, 255, 0.5);
}

.event-status i {
  margin-right: 5px;
}

.warning .event-status {
  background-color: #faad14;
  color: #fff;
}

.danger .event-status {
  background-color: #f5222d;
  color: #fff;
}

.event-content {
  padding: 15px;
}

.community-name {
  margin: 0 0 10px 0;
  font-size: 16px;
  font-weight: 500;
  color: #fff;
}

.event-desc {
  margin: 0 0 15px 0;
  color: #b4c2d1;
  line-height: 1.5;
}

.event-meta {
  padding-top: 10px;
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  color: #86909c;
}

.event-actions {
  display: flex;
  justify-content: flex-end;
  padding: 10px 15px;
  background-color: rgba(255, 255, 255, 0.03);
  border-top: 1px solid #2a4361;
}

.action-btn {
  color: #0EE0D4;
  background:rgba(22, 93, 86, 0.6);
  padding: 8px 10px;
  border-radius: 4px;
  border: 1px solid rgba(14, 224, 212, 0.6);
  font-size: 13px;
}
.action-btn1 {
  color: rgba(255, 58, 58, 1);
  background:rgba(160, 26, 26, 0.6);
  padding: 8px 10px;
  border-radius: 4px;
  border: 1px solid rgba(255, 58, 58, 0.6);
  font-size: 13px;
}
.action-btn2 {
  color: rgba(58, 255, 111, 1);
  background:rgba(117, 224, 160, 0.4);
  padding: 8px 10px;
  border-radius: 4px;
  border: 1px solid rgba(117, 224, 160, 0.6);
  font-size: 13px;
}

.action-btn:hover {
  color: #0EE0D4;
}
</style>
